import isEmail from "validator/lib/isEmail";
import isMobilePhone from "validator/lib/isMobilePhone";
import { PHONE_REQUIREMENTS, ZIPCODE_REQUIREMENTS } from "../constants";

export const validateEmail = (email) => isEmail(email);

export const validateMobilePhone = (phone, locale = "en-US") => {
  // console.log(`[validateMobilePhone] phone: ${phone}, locale: ${locale}`);
  return isMobilePhone(phone, locale);
};

export const validatePhoneNumber = (phone) => PHONE_REQUIREMENTS.test(phone);

export const validateZipCode = (zip) => ZIPCODE_REQUIREMENTS.test(zip);
